/**
 * Roles ERP v2 — matriz de accesos oficial ("MODULOS Y ACCESOS - ERP -
 * GRAFTON LATAM.xlsx", 2026-09-11). Secciones del Ciclo A visibles por rol:
 *
 *   admin / bp / back_office → todas las secciones existentes
 *   kam                      → solo cotizaciones (+ home)
 *   compras                  → solo home (sus módulos — OC, proveedores,
 *                              SOLPE, HES — llegan en un próximo ciclo)
 *
 * super-admin de plataforma siempre ve todo. Espejo del backend:
 * validators/shared.validator.js (validateErpRoles).
 */

export const ERP_SECTIONS = [
  'home',
  'clients',
  'quotations',
  'employees',
  'contracts',
  'export',
  'jobTitles',
  'configuration',
];

const SECTIONS_BY_ROLE = {
  admin: ERP_SECTIONS,
  bp: ERP_SECTIONS,
  back_office: ERP_SECTIONS,
  kam: ['home', 'quotations'],
  compras: ['home'],
};

export const erpSectionsFor = (user, erpRole) => {
  if (user?.rol === 'super-admin') return ERP_SECTIONS;
  return SECTIONS_BY_ROLE[erpRole] || [];
};

export const canSeeErpSection = (user, erpRole, section) =>
  erpSectionsFor(user, erpRole).includes(section);
